import axios from "axios";
import { createContext, useState } from "react";

export const RequestContext = createContext();

/**
 * Server bilan bitta aloqa nuqtasi.
 *
 * Ilgari har qanday nosozlik "Xatolik yuz berdi" degan bitta matnga
 * aylanardi -- parol noto'g'rimi, sessiya tugadimi yoki server o'chdimi,
 * bilib bo'lmasdi. Endi sabab aytiladi va sessiya tugagan bo'lsa kirish
 * sahifasiga qaytariladi.
 */
const messageFromError = (err) => {
  if (err.code === "ECONNABORTED") return "Server javob bermadi. Qayta urinib ko'ring.";
  if (!err.response) return "Serverga ulanib bo'lmadi. Internetni tekshiring.";

  const { status, data } = err.response;
  if (status === 401) return "Sessiya tugadi. Qaytadan kiring.";
  if (status === 403) return "Bu amal uchun huquqingiz yo'q.";
  if (status === 404) return "Ma'lumot topilmadi.";
  if (status === 413) return "Fayl juda katta.";
  if (status >= 500) return "Serverda xato. Birozdan keyin urinib ko'ring.";

  if (typeof data === "string" && data.trim()) return data;
  // Server tekshiruv xatolarini `errors` ro'yxatida yuboradi va aynan u
  // foydali: «Parol: kamida 6 belgi», «Region: to'ldirilishi shart».
  // Ilgari faqat `message` o'qilardi va u doim quruq «Bad request» edi --
  // qaysi katak xato ekani ko'rinmasdi.
  if (Array.isArray(data?.errors) && data.errors.length) return data.errors.join("; ");
  if (data?.message) return data.message;
  return `Xato (${status}).`;
};

const RequestContextProvider = ({ children }) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const request = async (url, method, body, type = "application/json") => {
    setLoading(true);
    const token = localStorage.getItem("token");
    try {
      const response = await axios({
        url: process.env.REACT_APP_API + url,
        method,
        data: body,
        timeout: 120000,
        headers: {
          Authorization: token,
          "Content-Type": type,
        },
      });
      setData((prev) => ({ ...prev, [url]: response.data.data }));
      if (method !== "GET") setSuccess("Bajarildi");
      return response.data;
    } catch (err) {
      if (err.response?.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        window.location.href = "/login";
        return undefined;
      }
      setError(messageFromError(err));
      return undefined;
    } finally {
      setLoading(false);
    }
  };

  return (
    <RequestContext.Provider
      value={{
        data,
        setData,
        loading,
        setLoading,
        error,
        setError,
        success,
        setSuccess,
        request,
      }}
    >
      {children}
    </RequestContext.Provider>
  );
};

export default RequestContextProvider;
